import axios from "axios";
import { DOC_NAV, DOC_NAV_MANIFEST } from "../../pages/docs/config/docNav.config";
import { getSectionConfig } from "../../pages/docs/config/sections";
import { getRouteForSectionId } from "../docUtils/docsRouteUtils";
import {
  isDocsLocalMode,
  isDocsS3Configured,
  DOCS_CDN_URL,
} from "../../pages/docs/constants/docsEnv";

function logFetchError(message, error) {
  if (process.env.NODE_ENV === "development") {
    console.error(message, error);
  }
}

/**
 * Load docs navigation manifest (local bundle or S3 nav.json).
 */
export async function loadNavConfig() {
  if (isDocsLocalMode()) {
    return { ok: true, groups: DOC_NAV, manifest: DOC_NAV_MANIFEST };
  }

  if (!isDocsS3Configured()) {
    return {
      ok: false,
      error: new Error("REACT_APP_DOCS_CDN_URL is required when REACT_APP_DOCS_SOURCE=s3"),
    };
  }

  try {
    const { data: manifest } = await axios.get(`${DOCS_CDN_URL}/nav.json`);

    if (!Array.isArray(manifest?.groups)) {
      throw new Error("nav.json is missing groups array");
    }

    return { ok: true, groups: manifest.groups, manifest };
  } catch (error) {
    logFetchError("[docs] Failed to load nav.json from S3", error);
    return { ok: false, error };
  }
}

/**
 * Load a docs section config by nav section id (local bundle or S3 sections/{route}.json).
 */
export async function loadSectionConfig(docNav, sectionId) {
  if (isDocsLocalMode()) {
    return getSectionConfig(sectionId);
  }

  if (!isDocsS3Configured() || !docNav) {
    return null;
  }

  const route = getRouteForSectionId(docNav, sectionId);
  if (!route) {
    return null;
  }

  try {
    const { data: config } = await axios.get(`${DOCS_CDN_URL}/sections/${route}.json`);
    return config;
  } catch (error) {
    logFetchError(`[docs] Failed to load section ${sectionId} from S3`, error);
    return null;
  }
}
